import React, { useEffect } from "react";
import { useRightSidebar } from "../../Context/TaskManagerNotification";
import TaskNotification from "../../pages/TaskDashboard/TaskNotification";
import { Bell } from "lucide-react";

const TaskNotificationSidebar: React.FC = () => {
  const { isOpen, close } = useRightSidebar();

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") close();
    };
    if (isOpen) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", onKey);
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, close]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex"
      aria-hidden={!isOpen}
      onClick={close}
    >
      <div className="absolute inset-0 bg-black/10" />

      <div
        className="ml-auto relative w-full sm:w-[580px] max-w-full h-full transform transition-transform duration-300 ease-out"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="h-full flex flex-col">
          <div className="h-full bg-white shadow-xl border border-gray-200 flex flex-col">
            <div
              className="flex items-center justify-between p-4 border-b sticky top-0 z-10 bg-white"
              role="banner"
            >
              <div className="flex items-center gap-2">
                <Bell size={18} />
                <h3 className="text-lg font-semibold">Notifications</h3>
              </div>
              <button
                onClick={close}
                className="text-gray-600 hover:text-gray-900 p-1 rounded"
                aria-label="Close notifications"
              >
                ✕
              </button>
            </div>

            <div className="flex-1 overflow-auto pb-4">
              <TaskNotification className="w-full p-0 bg-transparent shadow-none border-none" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskNotificationSidebar;
